import {
  GlobalNewsSkeleton,
  useSkeletonOpacity,
} from "@/src/components/news/loading-skeleton/news-card-skeleton";
import { Animated, Platform, View, useWindowDimensions } from "react-native";

const isWeb = Platform.OS === "web";

const Block = ({ className, style }: { className: string; style?: object }) => (
  <View className={`rounded-md bg-ash-3 ${className}`} style={style} />
);

export const NewsDetailContentSkeleton = () => {
  const opacity = useSkeletonOpacity();

  return (
    <Animated.View style={{ opacity }} className="flex-col flex-1 gap-4">
      {isWeb && (
        <View className="flex-row items-center border border-ash-3 bg-chalk px-4 py-5 rounded-2xl gap-3">
          <Block className="h-4 w-16" />
          <Block className="h-4 flex-1 mx-8" />
          <Block className="h-4 w-16 opacity-0" />
        </View>
      )}

      <View className="flex-1 border border-ash-3 bg-chalk rounded-2xl p-4 gap-4">
        {!isWeb && (
          <View className="flex-row items-center gap-3 mb-2">
            <Block className="h-4 w-12" />
            <Block className="h-4 flex-1 mx-8" />
            <Block className="h-4 w-12 opacity-0" />
          </View>
        )}

        <View className="flex-row items-start justify-between gap-4 mt-2">
          <View className="flex-1 gap-2">
            <Block className="h-7 w-3/4" />
            <Block className="h-7 w-1/2" />

            <View className="flex-row gap-2 mt-1">
              <Block className="h-6 w-16 rounded-full" />
              <Block className="h-6 w-20 rounded-full" />
            </View>

            <View className="flex-row items-center gap-2 mt-1">
              <Block className="h-7 w-7 rounded-full" />
              <Block className="h-3 w-28" />
              <Block className="h-3 w-16" />
            </View>
          </View>

          <Block className="h-8 w-8 rounded-md" />
        </View>

        <Block
          className="w-full rounded-2xl mt-2"
          style={{ height: isWeb ? 360 : 180 }}
        />

        <View className="gap-2 mt-2">
          <Block className="h-3 w-full" />
          <Block className="h-3 w-11/12" />
          <Block className="h-3 w-full" />
          <Block className="h-3 w-4/5" />
          <Block className="h-3 w-full" />
          <Block className="h-3 w-3/4" />
          <Block className="h-3 w-full" />
          <Block className="h-3 w-5/6" />
          <Block className="h-3 w-full" />
          <Block className="h-3 w-2/3" />
        </View>

        <View className="border-t border-ash-3 pt-4 gap-3 mt-2">
          <Block className="h-4 w-24" />
          <View className="flex-row gap-3">
            <Block className="h-16 w-24 rounded-xl" />
            <Block className="h-16 w-24 rounded-xl" />
          </View>
        </View>
      </View>
    </Animated.View>
  );
};

export const NewsDetailSkeleton = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  return (
    <View className="flex-row flex-1 gap-4 bg-obsidian">
      <View className="flex-col flex-1 gap-4">
        <NewsDetailContentSkeleton />
      </View>
      {!isMobile && (
        <View className="w-[26%]">
          <GlobalNewsSkeleton />
        </View>
      )}
    </View>
  );
};
